import { type BreakpointToken } from '@repo/pandacss/styled-system/tokens';
import { nwBreakpoints } from '@repo/pandacss/breakpoints';

/** Numeric pixel value for a panda breakpoint (e.g. `bp('md')` → 1080). */
function bp(name: BreakpointToken): number {
  return nwBreakpoints[name];
}

/**
 * Media-query string matching widths strictly below the named breakpoint.
 * Mirrors MUI's `theme.breakpoints.down(...)` — subtracts 0.05px so the breakpoint value
 * itself falls into the next bucket up.
 *
 * @example
 *   useMediaQuery(down('sm')) // '(max-width: 767.95px)' — true when viewport < 768px
 */
export function down(name: BreakpointToken): string {
  return `(max-width: ${bp(name) - 0.05}px)`;
}

/**
 * Media-query string matching widths at or above the named breakpoint.
 *
 * @example
 *   useMediaQuery(up('md')) // '(min-width: 1080px)'
 */
export function up(name: BreakpointToken): string {
  return `(min-width: ${bp(name)}px)`;
}

/**
 * Media-query string matching widths within `[start, end)`.
 *
 * @example
 *   useMediaQuery(between('sm', 'md')) // matches 768px ≤ width < 1080px
 */
export function between(start: BreakpointToken, end: BreakpointToken): string {
  return `(min-width: ${bp(start)}px) and (max-width: ${bp(end) - 0.05}px)`;
}
